export const getEventClientCoordinates = event => {
  const rect = event.target.getBoundingClientRect();
  const xCoordinate = event.clientX - rect.left;
  const yCoordinate = event.clientY - rect.top / 2;
  return [xCoordinate, yCoordinate];
};

const ZERO = '0'.codePointAt(0);
const NINE = '9'.codePointAt(0);

/**
 * Reads the digits a layer source name ends with, e.g. `geojson-3` to `3`.
 *
 * Scanned from the end rather than matched with `/\d+$/`: that pattern
 * backtracks across every position when the name ends in non-digits, which is
 * super-linear on long names.
 *
 * @param {string} source - The layer's source name
 * @returns {number} The trailing number, or Infinity when there is none
 */
const trailingNumber = source => {
  let start = source.length;
  while (start > 0) {
    const code = source.codePointAt(start - 1);
    if (code < ZERO || code > NINE) break;
    start -= 1;
  }
  return start === source.length
    ? Infinity
    : Number.parseInt(source.slice(start), 10);
};

// find the map feature at the specified long lat
export const getTargetMapFeature = (map, lngLat) => {
  const point = map.project(lngLat);
  const foundFeatures = map.queryRenderedFeatures(point);
  // Find feature with the lowest source number
  const targetFeature = foundFeatures.reduce(
    (lowest, feature) => {
      const { source } = feature.layer;
      const number = trailingNumber(source);
      return number < (lowest.number || Infinity)
        ? { feature, number }
        : lowest;
    },
    { number: Infinity }
  ).feature;
  return targetFeature;
};
